<div class="student-play-container p-4">
    <div class="w-100 h-100 d-flex flex-column justify-content-center align-items-center gap-5">
        <img width="430" src="assets/images/sdg-action.png" alt="">
        <div *ngIf="isQuizExpired == 'no'" class="text-center">
            <p class="text-24-600-133 text-c4">{{'The game has ended!' | translate}}</p>
            <p class="text-16-400-150 text-c2">{{'Teacher will share the results with you.' | translate}}</p>
        </div>
        <div *ngIf="isQuizExpired == 'yes'" class="text-center">
            <p class="text-24-600-133 text-c4">{{'Quiz expired!' | translate}}</p>
        </div>
    </div>
</div>
